import { render, staticRenderFns } from "./ContractFileForm.vue?vue&type=template&id=58aa3850&scoped=true&"
import script from "./ContractFileForm.vue?vue&type=script&lang=ts&"
export * from "./ContractFileForm.vue?vue&type=script&lang=ts&"
import style0 from "./ContractFileForm.vue?vue&type=style&index=0&id=58aa3850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aa3850",
  null
  
)

export default component.exports